<template>
    <div class="main d-flex justify-content-center ">
        <div class="bg-g-transparent-light w-100">
            <div class="container">
                <div v-for="(item, index) in content['blank-wysiwyg'].data.items" :key="index" class="custom-content" v-html="item.text"></div>
            </div>
        </div>
    </div>
</template>

<script>
import PageLayoutContentMixin from "../../mixins/ContentMixin";

export default {
    name: "Blank",
    mixins: [PageLayoutContentMixin],
}
</script>

<style scoped>

</style>
